import React, { useEffect, useState } from 'react';
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/bancos/apkpush`;
export function useAndroidReceiptMatches(clienteId, enabled) {
  const [snapshot, setSnapshot] = useState({ client: null, matches: {} });
  useEffect(() => {
    if (!clienteId || !enabled) return;
    let disposed = false, running = false;
    const controller = new AbortController();
    async function load() {
      if (running) return;
      running = true;
      try {
        const response = await fetch(`${BASE}/receipt-matches?cliente_id=${encodeURIComponent(clienteId)}`, {
          signal: controller.signal, cache: 'no-store', headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
        });
        if (!response.ok) throw new Error('unavailable');
        const data = await response.json();
        if (!disposed) setSnapshot({ client: clienteId, matches: Object.fromEntries((data.matches || []).map(m => [m.receipt_id, m])) });
      } catch (_) { if (!disposed) setSnapshot({ client: clienteId, matches: {} }); }
      finally { running = false; }
    }
    load(); const timer = setInterval(load, 15000);
    return () => { disposed = true; clearInterval(timer); controller.abort(); };
  }, [clienteId, enabled]);
  return enabled && snapshot.client === clienteId ? snapshot.matches : {};
}
export default function AndroidReceiptMatchBadge({ match, onClick }) {
  if (!match?.active) return null;
  return <button type="button" onClick={onClick}
    className="text-purple-600 hover:text-purple-700 text-xl transition-transform hover:scale-110 cursor-pointer"
    aria-label="Coincidencia con aviso Android"
    title="Coincidencia con aviso Android · click para editar el estado manualmente">🟣</button>;
}
